import axios from 'axios';

const API_URL = 'https://fifty-two-in-the-lou-production.up.railway.app/api';

const getAuthHeader = (token) => ({
  Authorization: `Bearer ${token}`
});

const getAllPlaces = async (token, status, category, userAdded = false) => {
  const params = {};
  if (status && status !== '') params.status = status;
  if (category && category !== '') params.category = category;
  if (userAdded) params.userAdded = true;
  const response = await axios.get(`${API_URL}/checklist`, {
    headers: getAuthHeader(token),
    params
  });
  return response.data;
};

const addUserPlace = async (token, place) => {
  const response = await axios.post(`${API_URL}/checklist/user-place`, place, {
    headers: getAuthHeader(token)
  });
  return response.data;
};

const deleteUserPlace = async (token, id) => {
  await axios.delete(`${API_URL}/checklist/${id}/user-place`, {
    headers: getAuthHeader(token)
  });
};

const togglePlace = async (token, id) => {
  const response = await axios.put(`${API_URL}/checklist/${id}/toggle`, {}, {
    headers: getAuthHeader(token)
  });
  return response.data;
};

const resetChecklist = async (token) => {
  await axios.post(`${API_URL}/checklist/reset-all`, {}, {
    headers: getAuthHeader(token)
  });
};

const restoreUserPlaces = async (token) => {
  await axios.post(`${API_URL}/checklist/restore`, {}, {
    headers: getAuthHeader(token)
  });
};

const schedulePlace = async (token, id, scheduledDate) => {
  const response = await axios.put(`${API_URL}/checklist/${id}/schedule`, null, {
    headers: getAuthHeader(token),
    params: { scheduledDate }
  });
  return response.data;
};

const deleteSchedule = async (token, id) => {
  const response = await axios.delete(`${API_URL}/checklist/${id}/schedule`, {
    headers: getAuthHeader(token)
  });
  return response.data;
};

const placeService = {
  getAllPlaces,
  addUserPlace,
  deleteUserPlace,
  togglePlace,
  resetChecklist,
  restoreUserPlaces,
  schedulePlace,
  deleteSchedule
};
export default placeService;